import { render, staticRenderFns } from "./MDTerima.vue?vue&type=template&id=01b57931&"
import script from "./MDTerima.vue?vue&type=script&lang=js&"
export * from "./MDTerima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports